import { Button, Loader } from 'application/presentation/common/uiComponents'

import s from './PaymentWaiting.module.scss'

type Props = {
  onBackPress: () => void
}

export const PaymentWaiting = ({ onBackPress }: Props) => {
  return (
    <div className={s.container}>
      <Loader size={64} withoutMargin />

      <div className={s.text}>Проверяем статус оплаты...</div>

      <div className={s.text}>
        Если вы отменили оплату,
        <br />
        просто вернитесь назад
      </div>

      <Button type="button" onClick={onBackPress}>
        Назад
      </Button>
    </div>
  )
}
